import { render, staticRenderFns } from "./winners.page.vue?vue&type=template&id=3f335c67&scoped=true&"
import script from "./winners.page.vue?vue&type=script&lang=js&"
export * from "./winners.page.vue?vue&type=script&lang=js&"
import style0 from "./winners.page.vue?vue&type=style&index=0&id=3f335c67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f335c67",
  null
  
)

export default component.exports